import { useMemo } from 'react'

import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { clientDetailTabs } from 'modules/Clients/model/clientDetailTabs'

import { Tabs } from 'shared/ui/Tabs'

import './clientDetailNavigation.css'

const ClientDetailNavigation = () => {
  const { clientId } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const getPathnameAfterClientId = (): string | null => {
    if (clientId) {
      const pathSegments = location.pathname.split('/').filter(Boolean)
      const clientIdIndex = pathSegments.indexOf(clientId)
      return pathSegments[clientIdIndex + 1] ?? null
    }
    return null
  }

  const activeKey = useMemo(() => {
    return getPathnameAfterClientId()
  }, [pathname])

  const onTabClick = (key: string) => {
    navigate(key)
  }

  return (
    <div>
      <Tabs
        onTabClick={onTabClick}
        activeKey={activeKey ?? ''}
        items={clientDetailTabs}
        className="clientDetailTabs"
      />
    </div>
  )
}

export default ClientDetailNavigation
